import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxVodResponse, IGetCatchUpEpisodeListParams } from '../../../entity/interface/iMpxVodResponse';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';

export interface IGetMixedCatchUpEpisodesUseCase {
    execute(params: IGetCatchUpEpisodeListParams): Promise<IMpxVodResponse>;
}

export class GetMixedCatchUpEpisodesUseCase implements IGetMixedCatchUpEpisodesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetCatchUpEpisodeListParams): Promise<IMpxVodResponse> {
        return this.mpxRepository.getMixedCatchUpEpisodeList(params);
    }
}
